module.exports = __webpack_public_path__ + "static/media/gal-3.6afd41d3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Drone/gal-3.jpg
// module id = 306
// module chunks = 0